import apiRequest from 'client/helpers/apiRequest';
import NewsPage, { NewsItem } from '@interfaces/news-page';

export const fetchNewsPage = (pageNumber: number = 1, pageSize: number = 5) =>
    apiRequest.get<NewsPage>('/api/news', { params: { pageNumber, pageSize } });

export const fetchNews = (slug: string) => apiRequest.get<NewsItem>(`/api/news/${slug}`);
